import React from "react";
import "./QALKMContent.css";
import Button from '@mui/material/Button';
import Breadcrumb from "./Breadcrumb";
import mailData from "../Data/mailData.js";

function QALKMContent() {
    return (
        <>
            {/* <Breadcrumb/> */}
            {/* <div className="main-banner">
                <img src={process.env.PUBLIC_URL + "/images/QALKM/LKMQA-Banner.png"} alt="Banner" className="banner-img" />
                <div className="banner-content">
                    <h1>QA @ LKM</h1>
                    <p><i>Lorem ipsum is simply dummy text of the printing</i></p>
                </div>
            </div> */}
            <div className="QA_MainDiv">
                {/* <div className="QA_heading"><h2>QA @ LKM</h2></div> */}
                <div className="QA_LKM_Card">
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA2.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Create process documents, templates  and guidelines</h3>
                            <div className="QA_para">
                                <p>QA team ensures creation and modification of the process documents, templates and guidelines. L&TT team has to get familiarized with overall L&TT processes with QA team guidance. QA team ensures Process implementation and their adherence.</p>
                            </div>
                            {/* <Button variant="contained">View more</Button> */}
                        </div>
                    </div>
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA1.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Collaborate with track leads and  QA champions</h3>
                            <div className="QA_para">
                                <p>QA team collaborates with track leads and QA champions to ensure implementation of QA processes within the track. QA champions represent their track for QA activities.</p>
                            </div>
                            {/* <Button variant="contained">View more</Button> */}
                        </div>
                    </div>                                        
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA4.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Ensure artifacts are in place for all the tracks</h3>
                            <div className="QA_para">
                                <p>QA team liaises with QA champions for updation of QA artifacts of their track on 
                                    regular basis. Artifacts are verified for each track for their accuracy and 
                                    availability.
                                </p>
                            </div>
                            {/* <Button variant="contained" >View more</Button> */}
                        </div>
                    </div>
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA3.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Provide support on internal and external audits</h3>
                            <div className="QA_para">
                                <p>QA team will work with QA champions who are the primary owners for the tracks for internal audits. QA team represents L&TT team in all the external audits through showcasing the processes and artifacts to the auditors. QA team also conducts 
                                    internal audits for all the tracks on yearly basis.</p>
                            </div>
                            {/* <Button variant="contained">View more</Button> */}
                        </div>
                    </div>
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA5.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Strive for compliance to capability maturity model integration (CMMI) framework</h3>
                            <div className="QA_para">
                                <p>QA team works with track leads in general and QA champions in particular for driving 
                                    compliance with CMMI framework. CMMI helps integrate traditionally separate 
                                    organizational functions, set process improvement goals and priorities, 
                                    provide guidance for quality processes, and provide a point of reference for 
                                    appraising current processes.
                                </p>
                            </div>
                            {/* <Button variant="contained">View more</Button> */}
                        </div>
                    </div>
                    <div className="QA_card_wrapper">
                        <div className="QA_image_wrapper">
                            <img src={process.env.PUBLIC_URL + "/images/QALKM/LKM_QA6.png"} alt="QA" className="QA_cards" />
                        </div>
                        <div className="QA_content_wrapper" id="view_more">
                            <h3>Guide and share advice on QA practices</h3>
                            <div className="QA_para">
                                <p>QA team supports the L&TT team in terms of sharing the guidance and advice on QA best 
                                    practices. Adopting best practices will result in improvising the process activities 
                                    which will lead to continual improvement. QA team conducts awareness sessions on regular 
                                    basis to make them conversant with the QA processes and standard templates.
                                </p>
                            </div>
                            {/* <Button variant="contained">View more</Button> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="icons-container">
                <div className="icons-wrap">
                    <div className="icons-row row1">
                        <div className="icons-box">
                            <div className="img-link">
                                <img src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"} alt="Mailicon" className="group-img mailIcon" id="icon-chat" />
                                <a className="contact-us" target='_blank' href={`mailto: ${mailData.dellearningframework}`}><span className='menu-text'>Write to us</span></a> */}
                                {/* <span className="contact-word">Mail</span> */}
                            {/* </div>
                        </div>
                    </div>

                </div>
            </div> */}

            
        </>
    );
}

export default QALKMContent;
